import createReducer from 'macguffin/redux/createReducer'
import initialState from './initialState'
import {
  SET_SPINBUTTON_VISIBILITY,
  SET_REPLAYURL,
  SET_DIMENSIONS,
  TOGGLE_DIMENSIONS,
  SET_POPUP_SCREEN,
  SET_AUTOPLAY_RESTART,
  SET_SPIN_RING_ANIMATION,
} from './constants'
import { PLAY_DONE } from 'macguffin/redux/constants'

export default function UI(state = initialState, action) {
  switch (action.type) {
    case SET_SPINBUTTON_VISIBILITY: {
      const { spinButtonVisible } = action
      return createReducer(state, { spinButtonVisible })
    }
    case PLAY_DONE: {
      return createReducer(state, { spinButtonVisible: true })
    }
    case SET_REPLAYURL: {
      const { replayUrl } = action
      return createReducer(state, { replayUrl })
    }
    case SET_DIMENSIONS: {
      const { dimensions } = action
      return createReducer(state, { dimensions })
    }
    case TOGGLE_DIMENSIONS: {
      const { dimensionsDebug } = state
      const newDimensionsDebug = !dimensionsDebug
      return createReducer(state, { dimensionsDebug: newDimensionsDebug })
    }
    case SET_POPUP_SCREEN: {
      const { popupScreen } = action
      return createReducer(state, { popupScreen })
    }
    /**
     * TODO: Should be part of macguffin's state.autoPlay
     */
    case SET_AUTOPLAY_RESTART: {
      const { autoPlayReStart } = action
      return createReducer(state, { autoPlayReStart })
    }
    case SET_SPIN_RING_ANIMATION: {
      const { enableSpinRingAnimation } = action
      return createReducer(state, { enableSpinRingAnimation })
    }
    default:
      return state
  }
}
